"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemTag = void 0;
exports.isSystemTag = isSystemTag;
var SystemTag;
(function (SystemTag) {
    SystemTag["deleted"] = "st_deleted";
})(SystemTag || (exports.SystemTag = SystemTag = {}));
function isSystemTag(tag) {
    return tag.indexOf('st_') === 0;
}
//# sourceMappingURL=tag.js.map